import * as Cases from '../slices/casesSlice';
import { getUkDate } from '../utilities';
import HistoryStatus from './historystatus';

const HistoryItem = (item: Cases.caseHistoryItemState) => {
    return (
        <div className="row">
            <div style={{ padding: 4, borderBottom: '1px solid #F4941E', color: 'black' }}>
                <div style={{ alignItems: 'center' }} className="row100" key={item.historyrowid}>
                    <div className="flexGrow1" style={{ padding: '4px 0', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        <div style={{ marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>{getUkDate(item.HistoryDate)}</div>
                    </div>
                    <div className="flexGrow3" style={{ padding: '4px 0', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        <div style={{ marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>{item.Details}</div>
                    </div>
                    <div className="flexGrow1" style={{ padding: '4px 0', overflow: 'hidden', textOverflow: 'ellipsis', justifyContent: 'flex-end' }}>
                        <HistoryStatus {...item}></HistoryStatus>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HistoryItem;